export async function packageEventDimensionOption(parameterList) {
    return new Promise((resolve, reject) => {
        let defaultDimensionOption = [
            {
                label: '用户标签',
                value: 'clientTag',
                parameterType: 'STRING',
                dimensionType: 'EVENT_DATA_PARAM_FIELD'
            },
            {
                label: '操作系统',
                value: 'operationSystem.name',
                parameterType: 'STRING',
                dimensionType: 'INTERNAL_DIMENSION'
            },
            {
                label: '位置: 国家',
                value: 'requestAddressInfo.ip.locationAddress.country',
                parameterType: 'STRING',
                dimensionType: 'INTERNAL_DIMENSION'
            },
            {
                label: '位置: 省份',
                value: 'requestAddressInfo.ip.locationAddress.province',
                parameterType: 'STRING',
                dimensionType: 'INTERNAL_DIMENSION'
            },
            {
                label: '位置: 城市',
                value: 'requestAddressInfo.ip.locationAddress.city',
                parameterType: 'STRING',
                dimensionType: 'INTERNAL_DIMENSION'
            }
        ];
        parameterList.forEach((t, index) => {
            let option = {
                label: t.description,
                value: `value.${t.name}`,
                parameterType: t.type,
                dimensionType: 'EVENT_REPORT_PARAM_FIELD'
            };
            defaultDimensionOption.push(option);

            if (index === parameterList.length - 1) {
                resolve(defaultDimensionOption);
            }
        });
    });
}
